<template>
  <!-- 属性配置 -->
 <div class="app-container">
   <div class="formBox margbot" ref="searchBox">
      <el-form :inline="true" :model="searchFrom" ref="searchFrom" class="demo-form-inline" label-width="120px" size="mini">
        <div class="formItemBox">
              <el-form-item label="属性编码:" prop="attributeFlag">
                <el-input  placeholder="" maxlength="100" v-model="searchFrom.attributeFlag"></el-input>
              </el-form-item>
              <el-form-item label="属性名称:" prop="attributeName">
                <el-input  placeholder="" maxlength="100" v-model="searchFrom.attributeName"></el-input>
              </el-form-item>
              <el-form-item label="属性类型:" prop="attributeType">
                <el-select v-model="searchFrom.attributeType" placeholder="请选择">
                  <el-option  label="全部" value="" ></el-option>
                  <el-option  label="文本型" value="1" ></el-option>
                  <el-option  label="单选型" value="2" ></el-option>
                  <el-option  label="多选型" value="3" ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="使用状态:" prop="isUsed">
                <el-select v-model="searchFrom.isUsed" placeholder="请选择">
                  <el-option  label="全部" value="" ></el-option>
                  <el-option  label="已使用" value="0" ></el-option>
                  <el-option  label="未使用" value="1" ></el-option>
                </el-select>
              </el-form-item>
               <el-form-item label="使用场景:" prop="sceneId">
                <el-select v-model="searchFrom.sceneId" placeholder="请选择">
                  <!-- <el-option  label="全部" value="" ></el-option> -->
                  <el-option v-for="item in SYCJlist" :key="item.id"  :label="item.sceneName" :value="item.id" ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="经营业务:" prop="businessId">
                 <el-cascader
                    v-model="searchFrom.businessId"
                    :options="yewuTree"
                    :show-all-levels="false"
                    :props="{ expandTrigger: 'hover' ,label:'name',value:'id',emitPath:false}"
                   ></el-cascader>
            </el-form-item>
             <el-form-item label="创建时间:" prop="createTimes">
                <el-date-picker
                  v-model="searchFrom.createTimes"
                  type="daterange"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期">
                </el-date-picker>
             </el-form-item>
        </div>
       <div class="searchBtnBox">
          <el-form-item>
            <el-button type="primary"  class="allBtn"  @click="searchFn">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary"  class="allBtn" @click="resetForm('searchFrom')">重置</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary"  class="allBtn"  @click="addDeiver">新增</el-button>
          </el-form-item>
       </div>
      </el-form>
    </div>
    <!--  表格 -->
    <div class="table" :style="{height:h}">
      <el-table :data="tableList"  ref="table"  bordersize="mini"  @selection-change='selectGoods'
       @row-click="handleRowClick" height="100%" style="width: 100%" center border  class="tableComent">
        <!-- <el-table-column type="selection"  width="55" ></el-table-column> -->
        <el-table-column  type="index" prop="date" width="55" label="序号" ></el-table-column>
        <el-table-column label="操作" width="150">
          <template slot-scope="scope">
            <div>
              <el-button type="text" size="mini" @click="modifySave(scope.row)" v-if="scope.row.isUsed == 1 || (scope.row.isUsed == 0&&scope.row.attributeType==3)">修改</el-button>
              <el-button type="text" size="mini" @click="delFn(scope.row)" v-if="scope.row.isUsed == 1">删除</el-button>
              <el-button type="text" size="mini"  @click="optionProp(scope.row)" v-if="scope.row.attributeType!=1" >属性项</el-button>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="attributeFlag" width="150" :formatter="emptyFn"  label="属性编码" show-overflow-tooltip></el-table-column>
        <el-table-column prop="attributeName" width="190" :formatter="emptyFn" label="属性名称"></el-table-column>
        <el-table-column property="attributeType" label="属性类型" min-width="80">
          <template scope="scope">
            <div>
           {{[ "文本型", "单选型", "多选型" ][scope.row.attributeType-1]}}
            </div>
          </template>
        </el-table-column>
         <el-table-column prop="businessName" label="关联业务" width=" 190"></el-table-column>
        <el-table-column prop="sceneName" label="使用场景" width="180"></el-table-column>
         <el-table-column property="isUsed" label="使用状态" min-width="80">
          <template scope="scope">
            <div>
           {{[ "已使用", "未使用" ][scope.row.isUsed]}}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="attributeDefault" width="180" label="默认值" :formatter="emptyFn"></el-table-column>
        <el-table-column prop="attributeRemark" width="180" label="备注信息" :formatter="emptyFn"></el-table-column>
        <!-- <el-table-column prop="attributeDefault" width="180" :formatter="emptyFn"  label="默认值">
          <template scope="scope">
            <div>
              <div v-if="scope.row.attributeType==1">
                {{scope.row.attributeDefault}}
              </div>
              <div v-if="scope.row.attributeType==2">
                {{scope.row.attributeDefault==='0'?'是':'否'}}
              </div>
            </div>
          </template>
        </el-table-column> -->
        <el-table-column prop="attributeOptionsName" width="180" label="默认名称" :formatter="emptyFn"></el-table-column>
        <el-table-column prop="sysSceneName" label="系统场景" width="100"></el-table-column>
        <el-table-column prop="createUserName" width="120"   label="创建人" :formatter="emptyFn"></el-table-column>
        <el-table-column prop="createTime"  min-width="170" :formatter="dateTimeFormat" label="创建时间"></el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <div>
      <el-pagination background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchFrom.pageNo"
        :page-sizes="[50,100,200,1000]"
        :page-size="searchFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <!-- 添加属性 -->
     <!-- <el-dialog :title="title" @close="closeDialog" :close-on-click-modal="false" :close-on-press-escape="false"
     :visible.sync="propertyFN" width="800px" center>
      <div ref="searchBox" >
        <el-form  :inline="true"  :rules="rules" ref="addFrom" :model="addFrom"  class="demo-form-inline" label-width="140px" size="mini">
        <div class="">
            <div>
              <el-form-item label="属性名称:" prop="attributeName">
                <el-input  placeholder="" maxlength="30"  type="text" v-model="addFrom.attributeName" ></el-input>
              </el-form-item>
              <el-form-item label="属性编码:" prop="bianma" class="dingwei">
                <span>ARR</span><el-input  placeholder=""  maxlength="30"  type="text" v-model="addFrom.bianma" :class="{disabled:!isAdd}" :readonly="!isAdd"></el-input>
              </el-form-item>
              <el-form-item label="属性类型:" prop="attributeType">
               <el-select  v-model="addFrom.attributeType"  placeholder="请选择">
                <el-option v-for="val in sxlx" :label="val.name" :value="val.id" :key="val.id"></el-option>
               </el-select>
              </el-form-item>
              <business   openObjs='1' :addFrom="addFrom"   v-if="propertyFN" ></business>
              <el-form-item prop="sceneIdList" label="使用场景:" class="is-required" >
                <div style="width:500px">
                   <el-checkbox-group v-model="addFrom.sceneIdList">
                      <el-checkbox v-for="item in SYCJlist" :label="item.id"  :key="item.id">{{item.sceneName}}</el-checkbox>
                    </el-checkbox-group>
                </div>
            </el-form-item>
            <el-form-item prop="xtcj" label="系统场景:" >
              <el-checkbox-group v-model="addFrom.xtcj">
                <el-checkbox v-for="item in XTCJlist" :label="item.itemNo"  :key="item.id">{{item.showName}}</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
              <div class="margin-left:10px">
                <el-form-item label="默认值:" prop="attributeDefault" v-if="addFrom.attributeType != ''">
                 <div v-if="addFrom.attributeType==1">
                  <el-input style="width: 430px" maxlength="100"  type="textarea" v-model="addFrom.attributeDefault"></el-input>
                 </div>
                 <div v-if="addFrom.attributeType==2">
                   <el-radio v-model="addFrom.attributeDefault" label="0">是</el-radio>
                   <el-radio v-model="addFrom.attributeDefault" label="1">否</el-radio>
                 </div>
                </el-form-item>
              </div>
              <div>
                <el-form-item label="备注信息:" prop="attributeRemark">
                 <el-input style="width: 430px" type="textarea" maxlength="200" v-model="addFrom.attributeRemark"></el-input>
                </el-form-item>
              </div>
            </div>
        </div>
       </el-form>
       </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size='mini'  @click="saveFn('addFrom')" :loading='addLoading'>确定</el-button>
        <el-button @click="propertyFN = false">取消</el-button>
      </span>
    </el-dialog> -->

    <!-- 添加 -->
    <el-drawer :title="title" @close="closeDialog"  direction="ltr" size="50%"  :visible.sync="propertyFN" :close-on-press-escape="false" :wrapperClosable="false" >
        <el-form  :inline="true"  :rules="rules" ref="addFrom" :model="addFrom"  class="demo-form-inline" label-width="140px" size="mini">
      <div>
        <div class="inpBox1">
        <div style="padding-top:20px">
          <div>
            <div>
              <el-form-item label="属性名称:" prop="attributeName" v-if="addFrom.isUsed == 0 && addFrom.attributeType == 3">
                <el-input  placeholder="" maxlength="30"  type="text" v-model="addFrom.attributeName" disabled></el-input>
              </el-form-item>
              <el-form-item label="属性名称:" prop="attributeName" v-else>
                <el-input  placeholder="" maxlength="30"  type="text" v-model="addFrom.attributeName" ></el-input>
              </el-form-item>
            </div>
            <el-form-item label="属性编码:" prop="bianma" class="dingwei" >
              <span>ARR</span><el-input  placeholder=""  maxlength="30"  type="text" v-model="addFrom.bianma" :class="{disabled:!isAdd}" :readonly="!isAdd"></el-input>
            </el-form-item>
            <div>
              <el-form-item label="属性类型:" prop="attributeType" v-if="addFrom.isUsed == 0 && addFrom.attributeType == 3">
                <el-select  v-model="addFrom.attributeType"  placeholder="请选择" disabled>
                  <el-option v-for="val in sxlx" :label="val.name" :value="val.id" :key="val.id" ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="属性类型:" prop="attributeType"  v-else >
                <el-select  v-model="addFrom.attributeType"  placeholder="请选择" @change="typeChange">
                  <el-option v-for="val in sxlx" :label="val.name" :value="val.id" :key="val.id" ></el-option>
                </el-select>
              </el-form-item>
            </div>
            <div>
              <business   :openObjs=1 :addFrom="addFrom"   v-if="addFrom.isUsed==1"></business>
              <el-form-item label="业务类型:" prop="attributeType" v-else class="is-required yewuBox">
                <el-tag  v-for="item in addFrom.businessNameList" :key="item" >
                   <el-tooltip class="item" effect="dark" :content="item" placement="top-start"> <span>{{ item }}</span> </el-tooltip>
                </el-tag>
              </el-form-item>

            </div>
            <div>
              <el-form-item prop="sceneIdList" label="使用场景:" class="is-required yewuBox"  v-if="addFrom.isUsed == 0 && addFrom.attributeType == 3" >
                <el-checkbox-group v-model="addFrom.sceneIdList" disabled>
                  <el-checkbox v-for="item in SYCJlist" :label="item.id"  :key="item.id">{{item.sceneName}}</el-checkbox>
                </el-checkbox-group>
              </el-form-item>
              <el-form-item prop="sceneIdList" label="使用场景:" class="is-required yewuBox"  v-else>
                <el-checkbox-group v-model="addFrom.sceneIdList" >
                  <el-checkbox v-for="item in SYCJlist" :label="item.id"  :key="item.id">{{item.sceneName}}</el-checkbox>
                </el-checkbox-group>
              </el-form-item>
            </div>
            <div>
              <el-form-item prop="xtcj" label="系统场景:" v-if="addFrom.isUsed == 0 && addFrom.attributeType == 3">
                <el-checkbox-group v-model="addFrom.xtcj" disabled>
                  <el-checkbox v-for="item in XTCJlist" :label="item.itemNo"  :key="item.id">{{item.showName}}</el-checkbox>
                </el-checkbox-group>
              </el-form-item>
              <el-form-item prop="xtcj" label="系统场景:" v-else>
                <el-checkbox-group v-model="addFrom.xtcj">
                  <el-checkbox v-for="item in XTCJlist" :label="item.itemNo"  :key="item.id">{{item.showName}}</el-checkbox>
                </el-checkbox-group>
              </el-form-item>
            </div>
            <div>
              <el-form-item label="默认值:" prop="attributeDefault" v-if="addFrom.isUsed == 0 && addFrom.attributeType == 3"  :class="['is-required yewuBox','newcheck']">
                   <el-checkbox-group v-model="addFrom.attributeArr"  disabled >
                    <el-checkbox
                      v-for="item in addFrom.options"
                      v-if="item.optionName && item.optionValue"
                      :key="item.index"
                      :label="item.optionValue"
                      :disabled="item.flag"
                      >
                    <el-tooltip class="item" effect="dark" :content="item.optionName" placement="top-start">
                      <span>{{item.optionName}}</span>
                    </el-tooltip>
                    </el-checkbox>
                   </el-checkbox-group>
              </el-form-item>
               <!-- <el-form-item label="默认值:" prop="attributeDefault" v-if="addFrom.attributeType != ''"  :class="['is-required yewuBox','newcheck']"> -->
                <el-form-item label="默认值:" prop="attributeDefault" v-else  :class="['is-required yewuBox','newcheck']">
                 <div v-if="addFrom.attributeType==1">
                  <el-input style="width: 430px" maxlength="100"  type="textarea" v-model="addFrom.attributeDefault"></el-input>
                 </div>
                 <div v-if="addFrom.attributeType==2">
                   <!-- <el-radio v-model="addFrom.attributeDefault" label="0">是</el-radio>
                   <el-radio v-model="addFrom.attributeDefault" label="1">否</el-radio> -->
                  <el-radio-group v-model="addFrom.attributeDefault" >
                   <el-radio
                    v-for="item in addFrom.options"
                    v-if="item.optionName && item.optionValue"
                    :key="item.index"
                    :label="item.optionValue">
                    <el-tooltip class="item" effect="dark" :content="item.optionName" placement="top-start">
                      <span>{{item.optionName}}</span>
                    </el-tooltip>
                    </el-radio>
                  </el-radio-group>
                 </div>
                 <div v-if="addFrom.attributeType==3">
                   <el-checkbox-group v-model="addFrom.attributeArr">
                    <el-checkbox
                      v-for="item in addFrom.options"
                      v-if="item.optionName && item.optionValue"
                      :key="item.index"
                      :label="item.optionValue"
                      :disabled="item.flag"
                      >
                    <el-tooltip class="item" effect="dark" :content="item.optionName" placement="top-start">
                      <span>{{item.optionName}}</span>
                    </el-tooltip>
                    </el-checkbox>
                   </el-checkbox-group>
                 </div>
              </el-form-item>
            </div>
            <el-form-item label="备注信息:" prop="attributeRemark">
              <el-input style="width: 430px" type="textarea" maxlength="200" v-model="addFrom.attributeRemark" ></el-input>
            </el-form-item>
          </div>
        </div>
      </div>
      <div class="footerBox">
        <el-button   @click="propertyFN=false" style="padding: 12px 40px;">取消</el-button>
        <el-button type="primary"  size="medium"  style="padding: 12px 40px;" @click="saveFn('addFrom')" :loading='addLoading'>确定</el-button>
      </div>

      <el-drawer title="属性项维护" size="90%" @close="closeDialog1"   class="rightDrawer" :close-on-press-escape="false" :wrapperClosable="false"
      :modal-append-to-body="false" :modal="false"  :visible.sync="newpropertyFN" v-if="addFrom.attributeType == 2 || addFrom.attributeType == 3">
       <div class="addressBox">
          <span><i class="fa fa-bars" aria-hidden="true" style="color:#0c46a2;margin-left:5px;font-size: 16px"></i> 属性项</span>
          <el-button type="primary" class="allBtn" @click="addsxFn">新增</el-button>
       </div>
       <div :style="{height:h}">
        <el-table :data="addFrom.options" height="100%"  highlight-current-row  border center>
          <el-table-column fixed type="index" width="55" label="序号"></el-table-column>
        <el-table-column label="属性项名称" min-width="200">
          <template slot-scope="scope">
            <div>
            <el-form-item label="" :prop="'options.' +scope.$index+ '.optionName'" :key="scope.$index" :rules="rules.optionName" v-if="(!scope.row.id) || (addFrom.isUsed == 1)">
              <el-input  placeholder=""   maxlength="30"   v-model="addFrom.options[scope.$index].optionName" ></el-input>
            </el-form-item>
            <div v-else>
              {{addFrom.options[scope.$index].optionName}}
            </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="属性项值" min-width="200">
          <template slot-scope="scope">
            <div>
            <el-form-item label="" :prop="'options.' +scope.$index+ '.optionValue'" :key="scope.$index" :rules="rules.optionValue"  v-if="(!scope.row.id) || (addFrom.isUsed == 1)">
              <el-input  placeholder=""   maxlength=" 40"   v-model="addFrom.options[scope.$index].optionValue"></el-input>
            </el-form-item>
            <div v-else>
              {{addFrom.options[scope.$index].optionValue}}
            </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="100">
          <template slot-scope="scope">
            <div>
              <el-button type="text" size="mini" v-if="(!scope.row.id) || (addFrom.isUsed == 1)" @click="delsxFn(scope.row,scope.$index)">删除</el-button>
            </div>
          </template>
        </el-table-column>
        </el-table>
      </div>
        <div class="footerBox">
          <el-button  type="primary" @click="newpropertyFN=false" style="padding: 12px 40px;" size="medium">关闭</el-button>
        </div>
      </el-drawer>
    </div>
  </el-form>
  </el-drawer>
    <!-- 属性项 -->
    <el-dialog title="属性项" :visible.sync="shuxing" @close="closeDialog" :close-on-click-modal="false" :close-on-press-escape="false"  width="850px" center>
       <div style="height:500px">
        <el-table :data="optionList" height="100%"  highlight-current-row  border >
          <el-table-column fixed type="index" width="55" label="序号"></el-table-column>
          <el-table-column prop="optionName" min-width="280" label="属性项名称"></el-table-column>
          <el-table-column label="属性项值" min-width="280" prop="optionValue"></el-table-column>
        </el-table>
       </div>
       <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="shuxing = false">关闭</el-button>
      </span>
    </el-dialog>
 </div>
</template>
<script>
import {
  sSceneList,
  sCrmDictionaryList,
  businessTree,
  sAttributeList, // 列表
  sAttributeAddOrUpdate, // 添加
  // attributeUpdate, // 修改
  sAttributeDelete, // 删除
  sAttributeDetail // 属性项维护详情
} from '@/api/newCrm'
import { getBtn } from '@/utils/getButton'
import { emptyFn, dateTimeFormat, arrChaJi } from '@/utils/util'
import business from '@/views/newCrm/components/business.vue'
export default {
  components: {
    business
  },
  data () {
    return {
      shuxing: false,
      optionList: [],
      delOptionIdList: [],
      sxList: [],
      checked: [],
      checkedArr: [],
      checkList: [
        { name: '租户', id: '1001' },
        { name: '客户', id: '1002' },
        { name: '用户', id: '1003' }
      ],
      sxlx: [
        { name: '文本型', id: 1 },
        { name: '单选型', id: 2 },
        { name: '多选型', id: 3 }
      ],
      emptyFn: emptyFn,
      dateTimeFormat: dateTimeFormat,
      // 添加属性
      addFrom: {
        attributeName: '',
        attributeType: '',
        attributeDefault: '',
        attributeRemark: '',
        xtcj: [],
        sceneIdList: [],
        options: [], // 属性项配置
        attributeArr: [], // 多选
        tAttribute: [] // 属性
      },
      propertyFN: false,
      newpropertyFN: false,
      title: '',
      addLoading: false,
      h: '500px',
      searchFrom: {
        pageNo: 1,
        pageSize: 50
      },
      tableList: [],
      loading: false,
      SYCJlist: [],
      XTCJlist: [],
      // 新增验证
      rules: {
        optionName: [
          { required: true, message: '请输入属性项名称', trigger: 'blur' }
        ],
        optionValue: [
          { required: true, message: '请输入属性项值', trigger: 'blur' }
        ],
        attributeName: [
          { required: true, message: '请输入属性名称', trigger: 'blur' }
        ],
        attributeType: [
          { required: true, message: '请选择属性类型', trigger: 'blur' }
        ],
        objClassify: [
          { required: true, message: '请选择使用对象', trigger: 'blur' }
        ],
        // attributeDefault: [
        //   { required: true, message: '请填写/选择默认值', trigger: 'blur' }
        // ],
        bianma: [
          { required: true, message: '请输入属性编码', trigger: 'blur' }
        ],
        attributeRemark: [
          { required: true, message: '请输入备注信息', trigger: 'blur' }
        ],
        xtcj: [
          { required: true, message: '请选择系统场景', trigger: 'blur' }
        ]
      },
      total: 0,
      yewuTree: [],
      oldBusinessIds: [],
      oldSceneIdList: [],
      isAdd: false,
      // 按钮
      btnFlg: [],
      btnIdArr: ['000P002B001', '000P002B002', '000P002B003']
    }
  },
  updated () {
    // this.getBtn()
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/tenant')
    sSceneList().then(res => {
      this.SYCJlist = res
    })
    sCrmDictionaryList({ groupNo: 'sys_scene' }).then(res => {
      this.XTCJlist = res
    })
    businessTree({ falg: 1 }).then(res => {
      this.yewuTree = this.sAttributeList(res)
    })
    this.getList(this.searchFrom)
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = (pH - h - 162) + 'px'
  },
  methods: {
    // 属性项
    optionProp (row) {
      this.shuxing = true
      sAttributeDetail({ id: row.id }).then(res => {
        console.log(res.options)
        this.optionList = res.options
      })
    },
    typeChange (val) {
      // console.log(val+'属性类型')
      this.$set(this.addFrom, 'attributeDefault', '')
      this.$set(this.addFrom, 'attributeArr', [])
      this.newpropertyFN = true
    },
    // 递归判断列表，把最后的children设为undefined
    sAttributeList (data) {
      for (var i = 0; i < data.length; i++) {
        if (data[i].children.length < 1) {
          // children若为空数组，则将children设为undefined
          data[i].children = undefined
        } else {
          // children若不为空数组，则继续 递归调用 本方法
          this.sAttributeList(data[i].children)
        }
      }
      return data
    },
    // 添加属性
    addDeiver () {
      this.addFrom.isUsed = 1
      this.title = '添加属性'
      this.propertyFN = true
      this.newpropertyFN = true
      this.addFrom.businessIdList = []
      this.isAdd = true
    },
    // 添加属性项
    addsxFn () {
      this.addFrom.options.push({})
    },
    // 删除属性项
    delsxFn (row, index) {
      this.$confirm('是否执行删除操作?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        this.addFrom.options.splice(index, 1)
        this.delOptionIdList.push(row.id)
      }).catch(() => {

      })
    },
    // 修改属性
    modifySave (row) {
      this.title = '修改属性'
      this.propertyFN = true
      this.newpropertyFN = true
      this.isAdd = false
      // this.addFrom = {
      //   id: row.id,
      //   attributeName: row.attributeName,
      //   attributeType: row.attributeType,
      //   attributeDefault: row.attributeDefault,
      //   attributeRemark: row.attributeRemark,
      //   bianma: row.attributeFlag.slice(3),
      //   xtcj: row.sysScene.split(','),
      //   businessIds: row.businessIds,
      //   businessName: row.businessName
      // }
      this.addFrom = { ...row }
      this.$set(this.addFrom, 'businessNameList', row.businessName.split(','))
      //  多选
      // console.log(row.attributeDefault);
      this.$set(this.addFrom, 'attributeArr', row.attributeDefault.split(','))

      this.$set(this.addFrom, 'bianma', row.attributeFlag.slice(3))
      this.$set(this.addFrom, 'xtcj', row.sysScene.split(','))
      let arr = row.businessIds.split(',')
      this.oldBusinessIds = []
      arr.forEach(item => {
        this.oldBusinessIds.push(Number(item))
      })

      let arr1 = row.sceneIds.split(',')
      this.oldSceneIdList = []
      this.addFrom.sceneIdList = []
      arr1.forEach(item => {
        this.oldSceneIdList.push(Number(item))
        this.addFrom.sceneIdList.push(Number(item))
      })

      sAttributeDetail({ id: row.id }).then(res => {
        // console.log(res.options)
        this.$set(this.addFrom, 'options', res.options)
        if (row.isUsed != 1) {
          this.addFrom.options.forEach((item, index) => {
            let flag = this.addFrom.attributeArr.some(item1 => item1 == item.optionValue)
            this.$set(this.addFrom.options[index], 'flag', flag)
          })
        }
      })
    },
    // 新增保存验证
    saveFn (formName) {
      const idsName = []
      const idsValue = []
      this.addFrom.options.forEach(value => {
        if (value.optionName) {
          idsName.push(value.optionName)
        }
        if (value.optionValue) {
          idsValue.push(value.optionValue)
        }
      })
      if (idsName.length > 0) {
        const idsSet = new Set(idsName)
        if ([...idsSet].length != idsName.length) {
          this.$alert('属性项名称不能重复', '系统提示')
          return
        }
      }
      if (idsValue.length > 0) {
        const idsSet = new Set(idsValue)
        if ([...idsSet].length != idsValue.length) {
          this.$alert('属性项值不能重复', '系统提示')
          return
        }
      }
      // 单选
      if (this.addFrom.attributeType == 2) {
        let shuxingName = []
        let arr = this.addFrom.attributeDefault.split()
        this.addFrom.attributeDefault.split().forEach((item, index) => {
          let falg = this.addFrom.options.some(item2 => item2.optionValue == item)
          if (falg) {
            shuxingName.push(this.addFrom.options.filter(item1 => item1.optionValue == item)[0].optionName)
          } else {
            arr.splice(index, 1)
          }
        })
        this.$set(this.addFrom, 'attributeDefault', arr.toString())
        this.addFrom.attributeOptionsName = shuxingName.toString()
      }
      // 多选
      // if (this.addFrom.attributeType == 3 && this.addFrom.attributeArr.length != 0) {
      if (this.addFrom.attributeType == 3) {
        let shuxingName = []
        let arr = JSON.parse(JSON.stringify(this.addFrom.attributeArr))
        this.addFrom.attributeArr.forEach((item, index) => {
          let falg = this.addFrom.options.some(item2 => item2.optionValue == item)
          if (falg) {
            shuxingName.push(this.addFrom.options.filter(item1 => item1.optionValue == item)[0].optionName)
          } else {
            arr.splice(index, 1)
          }
        })
        this.$set(this.addFrom, 'attributeDefault', arr.toString())
        this.addFrom.attributeOptionsName = shuxingName.toString()
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // if(!this.isAdd){
          //   this.addFrom.businessIdList = []
          //   if (this.addFrom.businessIds) {
          //     this.businessNameList = this.addFrom.businessName.split(',')
          //     let arr = this.addFrom.businessIds.split(',')
          //     arr.forEach(item => {
          //       this.addFrom.businessIdList.push(Number(item))
          //     })
          //   }
          // }

          if (!this.isAdd && (this.addFrom.isUsed == 0 && this.addFrom.attributeType == 3)) {
            this.addFrom.businessIdList = []
            if (this.addFrom.businessIds) {
              this.businessNameList = this.addFrom.businessName.split(',')
              let arr = this.addFrom.businessIds.split(',')
              arr.forEach(item => {
                this.addFrom.businessIdList.push(Number(item))
              })
            }
          }

          if (this.addFrom.businessIdList.length == 0) {
            this.$alert('请选择业务类型', '系统提示')
            return
          }

          if (this.addFrom.sceneIdList.length == 0) {
            this.$alert('请选择使用场景', '系统提示')
            return
          }
          // }
          // 删除
          this.$set(this.addFrom, 'delOptionIdList', this.delOptionIdList)
          // 删除
          this.$set(this.addFrom, 'delOptionIdLis', this.addFrom.attributeArr.toString())
          this.addLoading = true
          let sysSceneName = []
          this.addFrom.xtcj.forEach(item => {
            sysSceneName.push(this.XTCJlist.filter(item1 => item1.itemNo == item)[0].showName)
          })
          this.addFrom.sysSceneName = sysSceneName.toString()
          this.addFrom.SysScene = this.addFrom.xtcj.toString()
          this.addFrom.attributeFlag = 'ARR' + this.addFrom.bianma

          let newBusinessIdList = [...this.addFrom.businessIdList]
          // console.log(newBusinessIdList);
          let newSceneIdList = [...this.addFrom.sceneIdList]
          if (!this.isAdd) {
            this.addFrom.delBusinessIdList = arrChaJi(this.oldBusinessIds, newBusinessIdList, 1)
            this.addFrom.businessIdList = arrChaJi(this.oldBusinessIds, newBusinessIdList, 2)
            this.addFrom.delSceneIdList = arrChaJi(this.oldSceneIdList, newSceneIdList, 1)
            this.addFrom.sceneIdList = arrChaJi(this.oldSceneIdList, newSceneIdList, 2)
          }
          if (this.isAdd) {
            sAttributeAddOrUpdate(this.addFrom).then(res => {
              this.$message.success('添加成功')
              this.addLoading = false
              this.propertyFN = false
              this.newpropertyFN = false
              this.getList(this.searchFrom)
            }).catch(err => {
              this.addFrom.businessIdList = newBusinessIdList
              this.addFrom.sceneIdList = newSceneIdList
              this.$message.error(err.message)
              this.addLoading = false
            })
          } else {
            sAttributeAddOrUpdate(this.addFrom).then(res => {
              this.$message.success('修改成功')
              this.addLoading = false
              this.propertyFN = false
              this.newpropertyFN = false
              this.getList(this.searchFrom)
            }).catch(err => {
              this.addFrom.businessIdList = newBusinessIdList
              this.addFrom.sceneIdList = newSceneIdList
              this.$message.error(err.message)
              this.addLoading = false
            })
          }
        } else {
          return false
        }
      })
    },

    // 修改保存验证
    // changeBaoCun (formName) {
    //   this.$refs[formName].validate((valid) => {
    //     if (valid) {
    //       if (this.addFrom.businessIdList.length == 0 && this.isAdd ) {
    //         this.$alert('请选择业务类型', '系统提示')
    //         return
    //       }

    //       this.changeLoading = true

    //       let sysSceneName = []
    //       this.addFrom.xtcj.forEach(item => {
    //         sysSceneName.push(this.XTCJlist.filter(item1 => item1.itemNo == item)[0].showName)
    //       })
    //       this.addFrom.sysSceneName = sysSceneName.toString()
    //       this.addFrom.SysScene = this.addFrom.xtcj.toString()
    //       this.addFrom.attributeFlag = 'ARR' + this.addFrom.bianma
    //       attributeUpdate(this.addFrom).then(res => {
    //         this.$message.success('修改成功')
    //         this.changeLoading = false
    //         this.propertyFN = false
    //         this.getList(this.searchFrom)
    //       }).catch(err => {
    //         this.$message.error(err.message)
    //         this.changeLoading = false
    //       })
    //     } else {
    //       return false
    //     }
    //   })
    // },
    // 删除
    delFn (row) {
      this.$confirm('是否执行删除操作?', '系统提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        // let formData = new FormData()
        // formData.append('id', row.id)
        sAttributeDelete({ id: row.id }).then(res => {
          loading.close()
          this.$message({
            message: '删除成功',
            type: 'success'
          })
          this.getList(this.searchFrom)
        }).catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
      }).catch(() => {

      })
    },
    // 查选
    searchFn () {
      if (this.searchFrom.billNo) { this.searchFrom.billNos = this.searchFrom.billNo.split(/[(\r\n)\r\n]+/) } else {
        this.searchFrom.billNos = ''
      }
      this.getList(this.searchFrom)
    },
    // 选择数据
    selectGoods (selection) {
    },
    // 点击选中
    handleRowClick (row, column, event) {
      this.$refs.table.toggleRowSelection(row)
    },
    // 获取列表
    getList (searchFrom) {
      this.loading = true
      sAttributeList(searchFrom).then(res => {
        this.loading = false
        this.tableList = res.list
        this.total = res.total
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getList(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getList(this.searchFrom)
    },
    closeDialog1 () {
      // this.addFrom = {
      //   options: [], // 属性项配置
      // }
    },
    closeDialog () {
      this.delOptionIdList = []
      this.addFrom = {
        attributeName: '',
        attributeType: '',
        attributeDefault: '',
        attributeRemark: '',
        xtcj: [],
        sceneIdList: [],
        options: [], // 属性项配置
        attributeArr: [], // 多选
        tAttribute: [] // 属性
      }

      if (this.$refs['addFrom']) {
        this.$refs['addFrom'].clearValidate()
      }
    },
    // 重置
    resetForm (formName) {
      this.searchFrom = {
        pageNo: 1,
        pageSize: 50,
        createTimes: null
      }
    }
  }
}
</script>

<style scoped lang='less'>
.searchBtnBox {
  margin-left: 10px;
}
.inpBox{
  margin-left: -35px;
}
.inpBox .el-date-editor{
    width: 280px!important;
 }
.addinpBox .el-input{
  width: 210px;
}
.inpBox1 .el-form-item{
  margin-bottom: 17px!important;
}
.imgBox{
  display: flex;
  .item{
    display: flex;
     width: 50%;
     justify-content: space-around;
  }
  /deep/ .hide .el-upload--picture-card {
  display: none;
}
}
.riQiStyle{
  margin-top: -30px;
  margin-left: 120px;
}
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none!important;
  }
  input[type="number"]{
    -moz-appearance: textfield!important;
  }
  #mapBtn{
    cursor: pointer;
  }
.amap-demo {
    height: 500px;
  }
  .search-box {
    width:210px;
    height: 28px;
    border:solid 1px #ccc;
  }
  .amap-page-container {
    position: relative;
  }
.dingwei /deep/.el-form-item__content{
  position: relative;
  .el-input__inner{
    padding-left: 30px;
  }
  span{
    position: absolute;
    left: 2px;
    z-index: 999;
  }
}
/deep/.el-drawer__header {
   text-align: center;
}
.addressBox{
  display: flex;
  justify-content: space-between;
  margin: 10px;
}
.disabled /deep/.el-input__inner {
  background: #dcedff;
}
/deep/.el-input.is-disabled .el-input__inner {
    color: #000000;
    cursor: not-allowed;
}
/deep/.el-textarea.is-disabled .el-textarea__inner {
    color: #000000;
    cursor: not-allowed;
}
/deep/.el-checkbox__input.is-disabled+span.el-checkbox__label {
    color: #000000;
    cursor: not-allowed;
}
.yewuBox{
  display: flex;
 /deep/ .el-form-item__content{
    display: flex;
    flex-wrap: wrap;
  }
  /deep/.el-form-item__content {
    width: 521px;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
}
}
/deep/.el-tag{
  margin-right:15px;
  margin-bottom: 15px;
  display: inline-block;
  width: 22%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  position: relative;
 .el-tag__close{
    position: absolute;
    right: 2px;
    top: 8px;
  }
}
/deep/.el-checkbox__inner{
    width: 18px;
    height: 18px;
    margin-right: 5px;
}
/deep/.el-checkbox__inner::after{
    height: 9px;
    left: 6px;
    top: 1px;
}
/deep/.el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after {
 border-color: #303133;
}
/deep/.inpBox1 .el-input__inner {
    width: 180px;
}
/deep/ .el-checkbox {
    color: #606266;
    cursor: pointer;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    width: 200px;
    // width: 132px;
}
/deep/.el-checkbox__label {
 display: inline;
 padding-left: 10px;
 line-height: 28px;
 font-size: 14px;
}
/deep/.el-checkbox {
    color: #606266;
    cursor: pointer;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    width: 230px;
}
/deep/.el-checkbox__label {
 display: inline;
 padding-left: 5px;
 line-height: 28px;
 font-size: 14px;
}
 /deep/.el-radio, .el-radio__input {
    line-height: 2;
    outline: 0px;
    white-space: nowrap;
}
/deep/.el-radio {
    color: #606266;
    cursor: pointer;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    width: 230px;
}
/deep/.el-radio__inner{
    width: 18px;
    height: 18px;
    margin-right: 5px;
}
.newcheck /deep/.el-form-item__label:before{
    display: none;
}
</style>
